var React = require('react');

function Times (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.414 8l4.293-4.293a.999.999 0 1 0-1.414-1.414L8 6.586 3.707 2.293a.999.999 0 1 0-1.414 1.414L6.586 8l-4.293 4.293a.999.999 0 1 0 1.414 1.414L8 9.414l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L9.414 8z"}));
}

Times.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = Times;

Times.default = Times;
